import { SaleResponse } from "./sale.model";

export class AffiliateResponse {
	active: boolean;
	apellido: string;
	celular: string;
	code: string;
	company: number;
	creationDate: any;
	direccion: string;
	dpi: string;
	foto: any;
	id: number;
	mail: string;
	nacimiento: any;
	nit: string;
	nombre: string;
	points: number;
	vendorId: any;
}

export class AffiliateRequest {
	celular: string;
	direccion: string;
	dpi: string;
	foto: any;
	mail: string;
	nacimiento: any;
	nit: string;
	nombre: string;
	vendorId: any;
}

export class SchemaPointResponse {
	active: boolean;
	cash: number;
	company: number;
	creationDate: any;
	credit: number;
	id: number;
	nombre: string;
	points: number;
	quetzals: number;
	transfer: number;
}

export class SchemaPointRequest {
	cash: number;
	credit: number;
	nombre: string;
	points: number;
	quetzals: number;
	transfer: number;
}

export class AffiliateEventResponse {
	active: boolean;
	company: number;
	creationDate: any;
	endDate: any;
	id: number;
	multiplier: number;
	nombre: string;
	startDate: any;
}

export class AffiliateEventRequest {
	endDate: any;
	event: string;
	multiplier: number;
	startDate: any;
}

export interface AffiliatePointHistory {
	affiliate: number;
	clientInvoice: number;
	company: number;
	type: number;
	points: number;
	oldPoints: number;
	newPoints: number;
	createdBy: number;
	creationAt: string;
}
export interface AffiliatePointHistoryResponse {
	affiliatePointHistory: AffiliatePointHistory;
	affiliate: AffiliateResponse;
	clientInvoice: SaleResponse;
}